export const FileFormats = [
  ".jpg",
  ".jpeg",
  ".png",
  ".bmp",
  ".gif",
  ".svg",
  ".tiff",
  ".pdf",
  ".zip",
  ".rar",
  ".dwg",
  ".txt",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".avi",
  ".mpeg",
  ".mov",
  ".odp",
  ".key",
];

export const PreviewableFileFormats = ["pdf", "jpg", "jpeg", "png", "gif", "svg", "bmp", "plain",
'msword', // doc
'vnd.openxmlformats-officedocument.wordprocessingml.document'// docx
];
